import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import type { Editor } from '@tiptap/react'
import { useState } from 'react'

interface ImageDialogProps {
  editor: Editor
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function ImageDialog({ editor, open, onOpenChange }: ImageDialogProps) {
  const [src, setSrc] = useState('')
  const [alt, setAlt] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    e.stopPropagation()
    if (!src.trim()) return

    editor.chain().focus().setImage({ src: src.trim(), alt: alt.trim() || undefined }).run()

    setSrc('')
    setAlt('')
    onOpenChange(false)
  }

  const handleClose = (isOpen: boolean) => {
    if (!isOpen) {
      setSrc('')
      setAlt('')
    }
    onOpenChange(isOpen)
  }

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Insert Image</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="image-src">Image URL</Label>
            <Input
              id="image-src"
              data-testid="image-dialog-src"
              placeholder="https://example.com/image.png"
              value={src}
              onChange={(e) => setSrc(e.target.value)}
              autoFocus
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="image-alt">Alt Text</Label>
            <Input
              id="image-alt"
              data-testid="image-dialog-alt"
              placeholder="Image description"
              value={alt}
              onChange={(e) => setAlt(e.target.value)}
            />
          </div>
          <DialogFooter>
            <Button type="button" variant="ghost" onClick={() => handleClose(false)}>
              Cancel
            </Button>
            <Button type="submit">
              Insert
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}
